import { hotRanking } from '@/mocks/homeData';
import { useToast } from '@/hooks/useToast';

export default function HotRanking() {
  const { show, node } = useToast();

  return (
    <section id="hot" className="px-4 md:px-8 pt-16 md:pt-24">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.25em] text-primary-600">热度榜单</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              本期热度榜
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              按 24 小时内讨论量排序，热度与趋势每日重算一次，榜单只保留仍在发酵的话题。
            </p>
          </div>
          <button
            type="button"
            onClick={() => show('完整榜单即将上线，当前为演示入口')}
            className="self-start md:self-auto flex items-center gap-2 px-4 py-2.5 text-sm rounded-md border border-background-300 text-foreground-700 whitespace-nowrap transition-colors cursor-pointer hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-bar-chart-2-line w-4 h-4 flex items-center justify-center" />
            查看完整榜单
          </button>
        </div>

        <div className="mt-8 md:mt-10 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {hotRanking.map((item, index) => (
            <a
              key={item.rank}
              href="#features"
              className={`flex items-center gap-4 md:gap-6 px-4 md:px-6 py-5 transition-colors cursor-pointer hover:bg-background-100 ${
                index !== 0 ? 'border-t border-background-200' : ''
              }`}
            >
              <span
                className={`flex items-center justify-center w-9 h-9 md:w-11 md:h-11 shrink-0 rounded-md font-heading text-lg md:text-xl font-bold ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-700'
                }`}
              >
                {item.rank}
              </span>

              <span className="hidden sm:block w-16 h-16 md:w-20 md:h-20 shrink-0 overflow-hidden rounded-md">
                <img
                  src={item.thumb}
                  alt={`${item.title} 专题配图`}
                  title={`${item.title} 深扒`}
                  className="w-full h-full object-cover object-top"
                />
              </span>

              <span className="flex-1 min-w-0">
                <span className="flex items-center gap-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px]">
                    {item.tag}
                  </span>
                  <span
                    className={`text-xs font-medium ${
                      item.up ? 'text-primary-600' : 'text-foreground-500'
                    }`}
                  >
                    <i className={`${item.up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} mr-0.5`} />
                    {item.trend}
                  </span>
                </span>
                <span className="mt-1.5 block text-sm md:text-base font-medium text-foreground-900 truncate">
                  {item.title}
                </span>
                <span className="mt-1 hidden md:block text-xs text-foreground-500 line-clamp-1">
                  {item.summary}
                </span>
              </span>

              <span className="shrink-0 text-right">
                <span className="block text-[11px] text-foreground-500">讨论热度</span>
                <span className="mt-0.5 block font-heading text-base md:text-lg font-bold text-accent-700">
                  {item.heat}
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
      {node}
    </section>
  );
}